import React from 'react';
import ModalAcquirerFilterComponent from './modal-acquirer-filter.component';

function ModalAcquirerFilter(props) {
    return <ModalAcquirerFilterComponent {...props} />;
}

export default ModalAcquirerFilter;
